// HEAL-18 — точка входа в «Дополнительные показатели» (маркеры вне справочника,
// pending_review=TRUE). Живёт в ОБОИХ сегментах вкладки «Маркеры» («По органам» и
// «По категориям»): раньше карточка была только в «По категориям», и юзер, зашедший
// через органы, распознанных-но-несматченных показателей не видел вовсе.
//
// Вынесено в отдельный компонент намеренно: AC HEAL-18 требует одинакового счётчика
// и одного и того же экрана в обеих точках входа — с одним компонентом это нельзя
// разъехать копипастой. Счётчик всегда приходит из dashboard.extras_count (один
// источник, тот же предикат, что и у GET /biomarkers/extras).

import { AlertCircle, ChevronRight } from 'lucide-react';

export function ExtrasEntryCard({ count, onClick }: { count: number; onClick: () => void }) {
  return (
    <button
      type="button"
      onClick={onClick}
      className="flex w-full items-center gap-3 rounded-surface border border-dashed border-gray-300 bg-muted p-3 text-left transition hover:border-primary hover:bg-primary/5"
    >
      <div className="flex h-9 w-9 flex-shrink-0 items-center justify-center rounded-control border border-border bg-surface text-muted-foreground">
        <AlertCircle className="h-5 w-5" aria-hidden="true" />
      </div>
      <div className="min-w-0 flex-1">
        <div className="text-sm font-semibold text-foreground">Без оценки · {count}</div>
        <div className="text-hl-small text-muted-foreground">Распознаны, но оценить не смогли</div>
      </div>
      <ChevronRight className="h-4 w-4 flex-shrink-0 text-gray-400" aria-hidden="true" />
    </button>
  );
}
